module.exports = __webpack_public_path__ + "img/9788958072416.84ac8162.jpg";